import React from 'react'
import PropTypes from 'prop-types'
import SelectedSex from '../../components/SelectedSex/SelectedSex'

const P = ({ children }) =>
  <p className="mw7 center secondary-color ph3 ph4-ns pv4 f3-ns f4 lh-copy font-primary ma0">
    {children}
  </p>

const BoldSpan = ({ children }) =>
  <span className="secondary-color primary-font-bold">
    {children}
  </span>

const ComputedText = ({
  sex,
  age,
  diaper,
  amount,
  timesPrWeek,
  when,
  problem,
  checkup
}) =>
  <P>
    Du har en <BoldSpan>{sex}</BoldSpan> på <BoldSpan>{age}</BoldSpan> som {' '}
    <BoldSpan>{diaper}</BoldSpan>, tisser <BoldSpan>{amount.toLowerCase()}</BoldSpan>{' '}
    <BoldSpan>{when}</BoldSpan> <BoldSpan>{timesPrWeek}</BoldSpan> pr. uke, og {' '}
    <SelectedSex selectedSex={sex} /> synes det <BoldSpan>{problem}</BoldSpan>. Dere har{' '}
    <BoldSpan>{checkup}</BoldSpan>.
  </P>

ComputedText.propTypes = {
  sex: PropTypes.string,
  age: PropTypes.string,
  diaper: PropTypes.string,
  amount: PropTypes.string,
  when: PropTypes.string,
  problem: PropTypes.string,
  checkup: PropTypes.string
}

export default ComputedText



// WEBPACK FOOTER //
// ./src/components/ComputedText/ComputedText.js